import { graphql } from 'react-relay';

export const ChargeAddPaymentMethod = graphql`
  mutation ChargeAddPaymentMethodMutation(
    $input: ChargeAddPaymentMethodInput!
  ) {
    ChargeAddPaymentMethod(input: $input) {
      error
      charge {
        id
        status
        availablePaymentMethods
        company {
          projectType
          logo {
            url(fitIn: true)
          }
        }
        paymentMethods {
          ... on PaymentMethodITP {
            method
            authorizationUrl
          }
          ... on PaymentMethodInstallments {
            method
            subscription {
              installmentsCount
              currentInstallment {
                status
                charge {
                  status
                  paymentMethods {
                    ... on PaymentMethodPix {
                      method
                      brCode
                    }
                  }
                  ...PaymentActiveCob_charge
                }
              }
              paymentSubscriptionInstallments {
                edges {
                  node {
                    installmentNumber
                    status
                  }
                }
              }
              installmentsScheduled: paymentSubscriptionInstallments(
                filters: { status: "SCHEDULED" }
              ) {
                edges {
                  node {
                    value
                    status
                    installmentNumber
                  }
                }
              }
              installmentsActive: paymentSubscriptionInstallments(
                filters: { status: "ACTIVE" }
              ) {
                edges {
                  node {
                    status
                    installmentNumber
                  }
                }
              }
              installmentsExpired: paymentSubscriptionInstallments(
                filters: { status: "EXPIRED" }
              ) {
                edges {
                  node {
                    status
                    installmentNumber
                  }
                }
              }
              installmentsCompleted: paymentSubscriptionInstallments(
                filters: { status: "COMPLETED" }
              ) {
                edges {
                  node {
                    value
                    status
                    installmentNumber
                  }
                }
              }
            }
          }
        }
        ...Payment_charge
      }
    }
  }
`;
